export default function validation(response, messages) {
  response.data.error.validationErrors.forEach((error) => {
    const errorMessage = error.message;
    if (errorMessage && errorMessage.indexOf('IFECRITURE_IFLOT_TRANSMITTED') === 0) {
      messages.push({
        message: 'listeJournalEcriture.msgError.lotAssocieEtatTransmi',
      });
    }
    if (errorMessage && errorMessage.indexOf('IFLOT_TRANSMITTED') === 0) {
      messages.push({
        message: 'listeJournalEcriture.msgError.lotComptaEtatTransmi',
      });
    }
    if (errorMessage && errorMessage.indexOf('The Libelle field is required.') === 0) {
      messages.push({
        message: 'listeJournalEcriture.msgError.libelleObligatoire',
      });
    }
    if (errorMessage && errorMessage.indexOf('STRING_LENGTH_1_255') === 0) {
      messages.push({
        message: 'listeJournalEcriture.msgError.lengthFieldLibelle',
      });
    }
    if (errorMessage && errorMessage.indexOf('LOT_EXPORT_IMPOSSIBLE_INVALID_ACCOUNTING_WRITING') === 0) {
      const params = errorMessage.split('|')[0].split('@');
      messages.push({
        message: 'listeJournalEcriture.msgError.invalidAccountingWriting',
        parametres: {
          param1: params[1],
          param2: params[2],
          param3: params[3],
        },
      });
    }
    if (errorMessage && errorMessage.indexOf('ECRITURE_IS_IN_LOT') === 0) {
      messages.push({
        message: 'listeJournalEcriture.msgError.ecritureIsInLot',
      });
    }
  });
}
